<template>
  <div class="flex flex-row items-start md:items-center w-full justify-start md:justify-center">
    <div class="flex-1 border-t-2 border-amber-400 mx-2 hidden md:block"></div>
    <div class="md:bg-[#FAFAFA] px-4 flex justify-start md:justify-center w-fit max-w-full">
      <span class="text-emerald-700 text-l md:text-2xl font-semibold leading-normal md:text-center">
      {{ title }}
      </span>
    </div>
    <div class="flex-1 border-t-2 border-amber-400 mx-2 hidden md:block"></div>
  </div>
  <!-- <div class="title-about inline-relatife md:px-0 lg:px-0 xl:px-0 2xl:px-0">
    <div class="justify-start text-emerald-700 text-xl md:text-3xl font-semibold leading-normal">
      {{ title }}
    </div>
    <div class="border-t-2 border-amber-400 mt-1 w-full"></div>
  </div> -->
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  title: {
    type: String,
    required: true
  }
})
</script>
